import React from 'react';
import { Box } from '@mui/material';
import { MealCard } from './MealCard';
import { Meal } from '../../models/Meal';

type Props = {
    meals: Meal[];
};

export function DayMenu({ meals }: Props) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                // Optional: Some horizontal padding on the container if desired
                // p: 2
            }}
        >
            {meals.map(meal => (
                <Box
                    key={meal.id}
                    sx={{
                        width: { xs: '100%', sm: '50%', md: '33.333%' },
                        boxSizing: 'border-box',
                        p: 1
                    }}
                >
                    <MealCard meal={meal} />
                </Box>
            ))}
        </Box>
    );
}
